import { Pipe, PipeTransform } from '@angular/core';
import { DeviceInterface } from '../interfaces/device.interface';

@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {
  public transform(items: DeviceInterface[], term): any {
    return term ? items.filter(item => item.code.toLowerCase().indexOf(term.toLowerCase()) !== -1) : items;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/filter.pipe.ts